import { FC, ReactNode, useCallback } from 'react';
import { useForm, FormProvider, FormState } from 'react-hook-form';
import { Grid, Stack } from '@mui/material';

import { ValuesFieldForm } from './ValuesFieldForm';


export type FormData = Partial<Users.Preferences>;

interface Props {
    onSubmitRequest: (values: FormData) => void;
    onFieldChange?: (fieldName: string, value: any) => void;
    slots?: {
      footer?: ReactNode | ((formState: FormState<FormData>) => ReactNode);
    }
    defaultValues?: Partial<FormData>;
};

const DEFAULT_VALUES: Partial<FormData> = {
  leadershipValue1: '',
  leadershipValue2: '',
  leadershipValue3: '',
};


export const ValuesForm: FC<Props> = (props) => {
  const { onSubmitRequest, slots, defaultValues = DEFAULT_VALUES, onFieldChange } = props;

  const methods = useForm<FormData>({
    mode: 'onBlur',
    defaultValues: {
      ...DEFAULT_VALUES,
      ...defaultValues,
    },
  });

  const { handleSubmit, formState } = methods;

  const onSubmit = useCallback(async (data: FormData) => {
    const payload = {
      ...data,
    };

    return onSubmitRequest(payload);
  }, [onSubmitRequest]);

  const hints = [
    'What drives your decisions?',
    'What guides your leadership style?',
    'What defines your team culture?',
  ];

  const placeholders = [
    'e.g., Authentic leadership and transparency in all communications',
    'e.g., Data-driven decision making with stakeholder input',
    'e.g., Collaborative environment that fosters innovation',
  ];

  const suggestions = [
    'Authentic leadership and transparency',
    'Data-driven decision making',
    'Collaborative team environment',
    'Customer-centric approach',
  ];

  return (
    <FormProvider {...methods}>
      <form style={{ width: '100%', height: '100%' }} onSubmit={handleSubmit(onSubmit)}>
        <Stack justifyContent="space-between" height="100%" gap={4}>
          <Grid container spacing={3} mt={2}>
            {Array.from({ length: 3 }, (_, index) => (
              <ValuesFieldForm
                index={index}
                key={index}
                fieldPath={`leadershipValue${index + 1}`}
                placeholder={placeholders[index]}
                hint={hints[index]}
                suggestions={suggestions}
                onFieldChange={onFieldChange}
              />
            ))}

            <Grid size={12}>
              {typeof slots?.footer === 'function' ? slots?.footer(formState) : slots?.footer}
            </Grid>
          </Grid>

        </Stack>
      </form>
    </FormProvider>
  );
};
